<template>
  <ULink to="/" class="group flex justify-center items-center gap-2">
    <IconLogo class="bg-primary-50 size-9 group-hover:text-primary-700 group-hover:bg-primary-200 relative top-[-.1rem]" />
    <span class="font-logo text-xl font-black tracking-wider text-primary-50 group-hover:text-primary-200">Ongehoord</span>
  </ULink>
</template>
